import { proxy, useSnapshot } from "valtio";
import { fetchFeatureFlags } from "../../api/feature-flags";
import { sendWarningReport } from "../reporting";

export type SupportedFeatureFlags = "devtools" | "preEligibilityV2" | "arabicLocale" | string;

type FeatureFlagState = {
  initialised: boolean;
  featureFlags: SupportedFeatureFlags[];
};

export const featureFlagState = proxy<FeatureFlagState>({
  initialised: false,
  featureFlags: [],
});

export async function loadFeatureFlags({ forceReload = false } = {}) {
  try {
    if (!featureFlagState.initialised || forceReload) {
      const data = await fetchFeatureFlags();
      featureFlagState.featureFlags = data.map((flag) => flag.name);
      featureFlagState.initialised = true;
    }
  } catch (e) {
    sendWarningReport("Failed to load feature flags", e);
  }
}

export function useFeatureFlag(name: SupportedFeatureFlags) {
  const flags = useSnapshot(featureFlagState);
  const isEnabled = flags.featureFlags.includes(name);

  return {
    isEnabled,
  };
}
